<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M4 20H8L18.5 9.5C19.0523 8.9477 19.0523 8.0523 18.5 7.5L16.5 5.5C15.9477 4.9477 15.0523 4.9477 14.5 5.5L4 16V20Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M13 7L17 11" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" />
</svg>
